import { render, staticRenderFns } from "./voice_chat_dialog_custom.vue?vue&type=template&id=ebd7cb12&scoped=true"
import script from "./voice_chat_dialog_custom.vue?vue&type=script&lang=js"
export * from "./voice_chat_dialog_custom.vue?vue&type=script&lang=js"
import style0 from "./voice_chat_dialog_custom.vue?vue&type=style&index=0&id=ebd7cb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd7cb12",
  null
  
)

export default component.exports